import '@/i18n/config'; // Initialize i18n before React renders
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from '@config/theme';
import { router } from './router';
import '@/assets/styles/global.css';
import { logger } from '@utils/logger';
import { seedDatabase } from '@database/seed';

logger.info('CleanHands PWA starting...');

// Initialize the database before rendering React
async function initializeApp() {
  const loadingEl = document.getElementById('app-loading');

  try {
    logger.info('Initializing database...');
    await seedDatabase();
    logger.info('Database initialized successfully');
  } catch (error) {
    logger.error('Failed to initialize database:', error);
    // Graceful degradation - still render the app even if seeding fails
    // The user will see an empty category list which they can address
  } finally {
    // Hide loading indicator
    if (loadingEl) {
      loadingEl.style.display = 'none';
    }
  }

  // Render the React app
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </React.StrictMode>
  );
}

// Start the app
initializeApp();
